import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { AxiosResponse } from 'axios';
import { SnackbarActionTypes, useSnackbarDispatch } from 'contexts/snackbar/SnackbarContext';
import { usePost } from 'hooks/use-post';

import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { runR2Calibration } from 'views/bluviu-nutrition/features/calibrations/api/r2-calibration';
import { useCalibrationState } from '../../../context/calibration-context';
import { CalibrationsParams } from '../../../types/calibrations-params.type';

const RunR2Calibration: React.FC<{}> = ({}) => {
  const PAGE_NAME_ID = `bluViuNutrition.calibrations.editCalibration.runCalibration`;
  const params = useParams<CalibrationsParams>();
  const queryClient = useQueryClient();
  const snackbarDispatch = useSnackbarDispatch();

  const {
    r2CalibrationStatusQuery: { refetch: refetchCalibrationStatus, data: calibrationStatus },
  } = useCalibrationState();

  const calibrate = usePost<AxiosResponse, null>(
    () => runR2Calibration(params.globalSiteId, params.calibrationId),
    () => {
      snackbarDispatch({
        type: SnackbarActionTypes.SUCCESS_SNACKBAR,
        payload: { msg: 'Multi Cage Calibration started!' },
      });
      [['getCalibrations'], ['getR2Calibration', params.globalSiteId, params.calibrationId]].forEach((queryKey) => {
        queryClient.invalidateQueries({
          queryKey: queryKey,
        });
      });

      refetchCalibrationStatus();
    },
    (error) => {
      snackbarDispatch({
        type: SnackbarActionTypes.ERROR_SNACKBAR,
        payload: { msg: 'Error', error: error },
      });
    }
  );

  const handleRunCalibration = () => {
    calibrate.mutate(null);
  };

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <Typography>
        <FormattedMessage id={`${PAGE_NAME_ID}.information`} />
      </Typography>
      <Button
        onClick={() => handleRunCalibration()}
        disabled={calibrate.isPending || calibrationStatus?.calibrationIsRunning}
        startIcon={
          calibrate.isPending || calibrationStatus?.calibrationIsRunning ? <CircularProgress color="inherit" size={18} /> : null
        }>
        <FormattedMessage id={`${PAGE_NAME_ID}.button`} />
      </Button>
    </Box>
  );
};

export default React.memo(RunR2Calibration);
